import React, {useEffect, useState} from "react";
import {Form, Input, InputNumber, Modal, Select, message} from "antd";

// Add or change a queue, building or section: fields [{ key, label, kind: text | count | select, options, required,
// disabled, extra, max }]; save(values) returns a promise; a server error goes under its field
export const EntityModal = ({title, fields, initial, save, onClose, onSaved}) => {
  const [form] = Form.useForm()
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    form.setFieldsValue(initial || {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const submit = async () => {
    let values
    try {
      values = await form.validateFields()
    } catch (e) {
      return
    }
    const changes = {}
    fields.forEach(({key, disabled}) => {
      if (!disabled) changes[key] = values[key] === undefined || values[key] === '' ? null : values[key]
    })
    setSaving(true)
    try {
      await save(changes)
      message.success('Сохранено')
      onSaved()
    } catch (error) {
      const {message: text, field} = error?.response?.data?.errors || {}
      if (field && fields.some((f) => f.key === field)) form.setFields([{name: field, errors: [text]}])
      else message.error(text || 'Не удалось сохранить')
    }
    setSaving(false)
  }

  return (
    <Modal visible title={title} okText='Сохранить' cancelText='Отмена' onOk={submit} confirmLoading={saving} onCancel={onClose} destroyOnClose>
      <Form form={form} layout='vertical' onFinish={submit}>
        {fields.map(({key, label, kind, options, required, disabled, extra, max}) => (
          <Form.Item
            key={key}
            name={key}
            label={label}
            extra={extra}
            rules={required ? [{required: true, whitespace: kind === 'text', message: 'Обязательное поле'}] : undefined}
          >
            {kind === 'count'
              ? <InputNumber min={1} max={max} precision={0} style={{width: '100%'}} disabled={disabled}/>
              : kind === 'select'
                ? <Select options={options} disabled={disabled}/>
                : <Input disabled={disabled} maxLength={100}/>}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  )
}
